import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiQuestionariosService } from '../../services/api-questionarios.service';

export const semQuestionarioPendenteGuard: CanActivateFn = () => {

  const router = inject(Router);
  const apiQuestionarios = inject(ApiQuestionariosService);

  return apiQuestionarios.verificarPendentesNoAcessoAoSistema().pipe(
    map(lista => lista.length === 0 ? true : router.parseUrl('/sistemas/questionarios')),
    catchError(() => of(true))
  );
};
